module.exports = __webpack_public_path__ + "1d92ca872ef6457f88718a98d38fda2d.svg";